import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { WA_LINK } from "./shared";
import WeddingMobileMenu from "./WeddingMobileMenu";
import { WEDDING_CITIES } from "@/weddingsConfig";
import { CITIES } from "@/cityConfig";

const T = {
  ru: { shop: "МАГАЗИН", all_weddings: "СВАДЬБЫ", blog: "БЛОГ", all_short: "ВСЕ", cta: "ЗАПРОСИТЬ СМЕТУ" },
  en: { shop: "SHOP", all_weddings: "ALL WEDDINGS", blog: "BLOG", all_short: "ALL", cta: "GET A QUOTE" },
  tr: { shop: "MAĞAZA", all_weddings: "TÜM DÜĞÜNLER", blog: "BLOG", all_short: "TÜMÜ", cta: "TEKLİF AL" },
};

export default function TopNav({ lang, switchLang, citySlug }) {
  const t = T[lang] || T.ru;
  // City label is shown in its native name per language
  const cfg = WEDDING_CITIES[citySlug];
  const cityLabel = cfg ? (lang === "ru" ? cfg.name : cfg.nameEn).toUpperCase() : "";
  // Shop link: city catalog only if it's a delivery city, otherwise homepage
  const shopHref = `${CITIES[citySlug] ? `/${citySlug}` : "/"}${lang !== "ru" ? `?lang=${lang}` : ""}`;
  return (
    <nav className="absolute top-0 left-0 right-0 z-30" data-testid="weddings-nav">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-4 sm:py-5 flex items-center justify-between">
        <div className="text-white"><Logo variant="gold" /></div>
        <div className="hidden lg:flex items-center gap-8 text-[12px] tracking-[0.2em] text-white/85 font-light">
          <Link to={shopHref} className="hover:text-white transition">
            {t.shop}
          </Link>
          <Link to={`/weddings${lang !== "ru" ? `?lang=${lang}` : ""}`} className="hover:text-white transition">
            {t.all_weddings}
          </Link>
          <span className="text-white font-medium border-b border-[#C9A87C] pb-1">
            {cityLabel}
          </span>
          <Link to={`/blog${lang !== "ru" ? `?lang=${lang}` : ""}`} className="hover:text-white transition">
            {t.blog}
          </Link>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <button onClick={switchLang} className="text-[11px] sm:text-[12px] tracking-[0.2em] text-white/85 hover:text-white px-2" data-testid="weddings-lang-switch">
            {lang.toUpperCase()}
          </button>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
             className="hidden md:inline-flex items-center px-6 py-3 bg-white text-[#1F1815] text-[11px] tracking-[0.25em] font-medium hover:bg-[#F5EDE0] transition rounded-sm"
             data-testid="weddings-nav-cta">
            {t.cta}
          </a>
          <WeddingMobileMenu lang={lang} citySlug={citySlug} />
        </div>
      </div>
    </nav>
  );
}
